// extracted by mini-css-extract-plugin
module.exports = {"fontSizeSmall":"style_fontSizeSmall__1pRsm4PajgC52LvYXS0_Wp"};